import { FileOutput } from "@models/configurators/outputs/file-output";
import { KbObjectManager } from "@models/configurators/kb-object-manager";
import { IOutput, IZipOutput } from "@models/entity-models";
import { eOutputType } from "@models/enums";
import { Kbo, KboOutput } from "@models/configurators/configurator-di";
import { CToken } from "@models/configurators/ctoken";

@KboOutput(CToken.ZipOutput, eOutputType.zip)
export class ZipOutput extends FileOutput implements IZipOutput {
    constructor(kom: KbObjectManager, args?: IOutput) {
        super(kom, args);
        this.type = eOutputType.zip;
    }
}
